import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-organizations-sidebar',
  templateUrl: './organizations-sidebar.component.html',
  styleUrls: ['./organizations-sidebar.component.scss']
})
export class OrganizationsSidebarComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
